import { render, staticRenderFns } from "./DrawerSection.vue?vue&type=template&id=4ba8c327&scoped=true"
import script from "./DrawerSection.vue?vue&type=script&lang=js"
export * from "./DrawerSection.vue?vue&type=script&lang=js"
import style0 from "./DrawerSection.vue?vue&type=style&index=0&id=4ba8c327&prod&lang=scss&scoped=true"
import style1 from "./DrawerSection.vue?vue&type=style&index=1&id=4ba8c327&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba8c327",
  null
  
)

export default component.exports